module.exports = __webpack_public_path__ + "img/2020_20191025_184240.8d55794f.jpg";